import { ComponentProps } from "react";
import * as React from "react";

import { AppHeader } from "./Header";

type MainProps = ComponentProps<"main">;

type Props = MainProps & {
  showHeader?: boolean;
  showFooter?: boolean; // TODO: implement footer
};

export const Layout: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  showHeader = true,
  showFooter = true,
  ...rest
}) => {
  return (
    <div>
      {showHeader && <AppHeader />}
      <main {...rest}>{children}</main>
      {showFooter && <Footer />}
    </div>
  );
};

const Footer = () => null;
